import pl from './pl';
import hu from './hu';
import en from './en';


export default { pl, hu, en };